export default function ChatBadge(props) {
  return (
    <div
    className="chat-online"
    >
      Online: <span className="chat-online-span"></span>{props.label ? props.label : 0}
    </div>
  );
}
